export default __webpack_public_path__ + "images/form-hero-mobile.2d93696082cee78549770db6625d8b1a.jpg";